import { createContext, useState } from 'react'
import { ConfirmDialog } from './ConfirmDialog'

type ConfirmOptions = {
  variant?: 'default' | 'destructive'
  title?: string
  description?: string
  content?: React.ReactNode
}

type ConfirmContextType = (options: string | ConfirmOptions) => Promise<boolean>

export const ConfirmContext = createContext<ConfirmContextType | null>(null)

export function ConfirmProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false)
  const [options, setOptions] = useState<ConfirmOptions>({})
  const [resolve, setResolve] = useState<(value: boolean) => void>()

  const confirm: ConfirmContextType = opts => {
    return new Promise(res => {
      if (typeof opts === 'string') {
        setOptions({ description: opts })
      } else {
        setOptions(opts)
      }

      setOpen(true)
      setResolve(() => res)
    })
  }

  const handleConfirm = () => {
    resolve?.(true)
    setOpen(false)
  }

  const handleCancel = () => {
    resolve?.(false)
    setOpen(false)
  }

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}

      <ConfirmDialog
        open={open}
        onOpenChange={o => {
          if (!o) handleCancel()
        }}
        variant={options.variant}
        title={options.title}
        description={options.description}
        content={options.content}
        onConfirm={handleConfirm}
      />
    </ConfirmContext.Provider>
  )
}
